<script setup>
import Odd from '../Odd.vue';
import HShirt from '../HShirt.vue';
import AShirt from '../AShirt.vue';
import { computed, ref ,watch, onUnmounted} from 'vue';
import { timestampToTime } from '@/helpers';
import { useRouter } from 'vue-router';
import StatsDropdown from '@/views/(app)/Partials/StatsDropdown.vue';
import Dropdown from '../Dropdown.vue';
import { THREE_WAY_SPORTS } from '@/mainMarkets';
const assetsUrl = import.meta.env.VITE_ASSETS_URL
const props = defineProps({
    event: Object,
    market: {
        type: [String, Number],
    },
    selections: {
        type: Array,
        default: () => []
    },
    scoreboard: Object,
})

defineEmits(['stats'])
const router = useRouter()
const isLive = computed(() => props.event.s == 0)
// 1 · X · 2 for a sport whose main market is 3-way (Soccer, Handball, Futsal), else 1 · 2
const isThreeWay = computed(() => THREE_WAY_SPORTS.includes(Number(props.event?.si)))
const homeScore = computed(() => props.scoreboard?.result?.split('-')[0])
const awayScore = computed(() => props.scoreboard?.result?.split('-')[1])

const liveSeconds = ref(0)
let timer = null
const homeKitError = ref(false)
const awayKitError = ref(false)
const newHomeRes = ref(false)
const newAwayRes = ref(false)
const showStats = ref(false)
const homeTeamRC = computed(() => {
    if (props.scoreboard?.inf?.RC ){ 
        if(props.scoreboard?.inf?.RC?.split('-')[0] !== '0'){ return true }
    }else{ return false}
})
const awayTeamRC = computed(() => {
    if (props.scoreboard?.inf?.RC ){ 
        if(props.scoreboard?.inf?.RC?.split('-')[1] !== '0'){ return true }
    }else{  return false }
})
const url = computed(() => isLive.value ? `/in-play/${props.event.i}` : `/pre/${props.event.i}`)

const goToDetails = () =>{ 
    router.push(url.value)
}
const toggleStats = () => (showStats.value = !showStats.value)

onUnmounted(() => {
  clearInterval(timer)
})
watch(
  () => props.scoreboard?.c,
  (newC) => {
    if (!isLive.value || !newC?.se) {
      clearInterval(timer)
      timer = null
      return
    }

    liveSeconds.value = newC.se

    clearInterval(timer)
    timer = null

    if (newC.s === "running") {
      timer = setInterval(() => {
        if (newC.d === "up") {
          liveSeconds.value++
        } else if (newC.d === "down" && liveSeconds.value > 0) {
          liveSeconds.value--
        }
      }, 1000)
    }
  },
  { immediate: true, deep: true }
)

watch(() => props.scoreboard?.result?.split('-')[0], (newVal, oldVal) => {
  if (!props.scoreboard?.result) return;
  if (oldVal !== undefined && newVal !== undefined && newVal !== oldVal) {
    newHomeRes.value = true;
    setTimeout(() => {
      newHomeRes.value = false;
    }, 5000);
  }
});

watch(() => props.scoreboard?.result?.split('-')[1], (newVal, oldVal) => {
  if (!props.scoreboard?.result) return;
  if (oldVal !== undefined && newVal !== undefined && newVal !== oldVal) {
    newAwayRes.value = true;
    setTimeout(() => {
      newAwayRes.value = false;
    }, 5000);
  }
});
const test = () =>{
    console.log('test')
}
</script>

<template>
    <div class="ev-Box" v-if="event">
        <div class="px-2 xl:px-7 my-3.5 flex gap-1 border-r border-neutral-600/50" @click="goToDetails">
            <div class="overflow-hidden ">
                <div class="ev-Teams" v-if="event.o =='false' || event.o == false">
                    <div class="flex items-center gap-1">
                        <div v-if="!homeKitError">
                            <img
                                v-if="event?.hi"
                                :src="`${assetsUrl}/teams/${event.hi}.png`"
                                class="w-[11px] h-[11px] object-contain min-w-[11px]"
                                 @error="homeKitError = true"
                            />
                        </div>
                        <div v-else class="w-[11px] h-[11px] min-w-[11px]">
                            <HShirt />
                        </div>
                        <p class="ev-Participant">{{ event.h}}</p>
                        <img v-if="homeTeamRC" src="/rc.svg" class="h-3"/> 
                        <p v-if="newHomeRes && event.si == 1 && isLive"class="text-[11px] font-bold px-0.5 text-gray-800 bg-[var(--color-yellow1)]">GOAL</p>
                    </div>
                    <div class="flex items-center gap-1">
                        <div v-if="!awayKitError">
                            <img
                                v-if="event?.ai"
                                :src="`${assetsUrl}/teams/${event.ai}.png`"
                                class="w-[11px] h-[11px] object-contain min-w-[11px]"
                                @error="awayKitError = true"
                            />
                        </div>
                        <div v-else class="w-[11px] h-[11px] min-w-[11px]">
                             <AShirt/>
                        </div>
                        <p class="ev-Participant">{{event.a}}</p>
                        <img v-if="awayTeamRC" src="/rc.svg" class="h-3"/>
                        <p v-if="newAwayRes && event.si == 1 && isLive" class="text-[10px] font-bold px-0.5 text-gray-800 bg-[var(--color-yellow1)]">GOAL</p>
                    </div>
                </div>
                <div class="ev-Teams" v-if="event.o == 'true' || event.o == true">
                    <p class="ev-Participant">{{ $t('events.outrightf')}}</p>
                </div>
                <div class="ev-Time">
                    <p class="text-[11px] text-white opacity-75" v-if="event.t">
                        <template v-if="!isLive">{{ timestampToTime(event.t) }}</template>
                        <template v-else>
                            <span v-if="scoreboard?.state">({{scoreboard?.state}})</span>
                            <span v-if="liveSeconds" class="ml-1">
                                {{ Math.floor(liveSeconds / 60) }}:{{ (liveSeconds % 60).toString().padStart(2, '0') }}
                            </span>
                        </template>
                    </p>

                    <div class="text-[11px] bg-[var(--color-primary5)] font-bold px-0.5 rounded-sm flex items-center h-3 ml-2">
                        <span >{{ event?.onr }} &raquo;</span>
                    </div>
                </div>
            </div>
            <div class="ml-auto flex items-center gap-1 flex-col justify-center" v-if="isLive">
                <div class="ev-ScoreBox">{{ homeScore }}</div>
                <div class="ev-ScoreBox mt-0.5">{{ awayScore }}</div>

                <div  v-if="event.si == 1">
                    <StatsDropdown
                        :event="event"
                        :isLive="isLive"
                        @open="test"
                    />
                </div>
            </div>
        </div>
        <div>  
            <ul class="list-none flex h-full" v-if="selections.length">
                <template v-if="isThreeWay">
                    <li class="flex-1">
                        <Odd :odd="selections[0].o?.find(s => s.n == '1')" :event="event" :mi="market"/>
                    </li>
                    <li class="flex-1">
                        <Odd :odd="selections[0].o?.find(s => s.n == 'X')" :event="event" :mi="market"/>
                    </li>
                    <li class="flex-1">
                        <Odd :odd="selections[0].o?.find(s => s.n == '2')" :event="event" :mi="market"/>
                    </li>
                </template>
                <template v-else>
                    <li class="flex-1">
                        <Odd :odd="selections[0].o?.find(s => s.n == '1')" :event="event" :mi="market"/>
                    </li>
                    <li class="flex-1">
                        <Odd :odd="selections[0].o?.find(s => s.n == '2')" :event="event" :mi="market"/>
                    </li>
                </template>
            </ul>
        </div>
    </div>
</template>
 
<style scoped>
.ev-Box {
    @apply grid grid-cols-2
}

.ev-Box:not(:last-of-type) {
    @apply border-b;
}

.ev-Time {
    @apply flex items-center;
}

.ev-Teams:hover .ev-Participant {
    color: var(--color-primary5);
}

/* .ev-Participant {
    @apply text-[13px] font-bold text-white text-ellipsis truncate flex items-center gap-1;
} */
.ev-Participant {
    @apply text-[13px] font-bold text-white flex items-center gap-1;
    /* width: 100%; */
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.ev-Teams {
    @apply flex-1 overflow-hidden whitespace-nowrap cursor-pointer;
}
.ev-ScoreBox {
    text-align: center;
    line-height: 15px;
    height: 19px;
    border-radius: 1px;
    background-color: var(--color-white10);
    padding: 2px 4px;
    width: 100%;
    font-size: 13px;
    font-weight: 700;
    white-space: nowrap;
    @apply text-white;
}

.ev-StatIcon {
    mask-image: url('/stat-icon.svg');
    background-color: var(--color-grey6);
    mask-size: 13px 13px;
    width: 13px;
    height: 13px;
    @apply ml-4;
}
ul {
    list-style-type: none !important;
    margin: 0;
    padding: 0;
}
</style>